// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InsertRowRightOutlinedSvg from "@ant-design/icons-svg/es/asn/InsertRowRightOutlined";
import AntdIcon from '../components/AntdIcon';

var InsertRowRightOutlined = function InsertRowRightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: InsertRowRightOutlinedSvg
  }));
};

InsertRowRightOutlined.displayName = 'InsertRowRightOutlined';
export default React.forwardRef(InsertRowRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/InsertRowRightOutlined.js
// module id = 1363
// module chunks = 0